import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {createRequestOption} from '../helpers/request-util';

@Injectable({
  providedIn: 'root'
})
export class EstadoComparendoUsuarioService {

  public resourceUrl = environment.apiUrl + 'comparendo/estado_comparendo_usuario';

  // public resourceUrl = "http://comparendo-microservice.gerenciaurbana.org:8084/" + 'comparendo';

  constructor(public http: HttpClient) {
  }

  create(estadoComparendoUsuario: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, estadoComparendoUsuario);
  }

  update(estadoComparendoUsuario: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, estadoComparendoUsuario);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  findLastByComparendoId(comparendoId: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/findLastByComparendoId/${comparendoId}`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, {params: options});
  }

  findByCriteria(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(`${this.resourceUrl}/findByCriteria`, {params: options});
  }

  countByEstado(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl + '/countByEstado', {params: options});
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }

}
